import Vue from 'vue'
import Router from 'vue-router'
// 模拟进度条
import NProgress from 'nprogress'
import { isMain } from '@/utils/tools'
// tools工具
import { setStorageToken, getStorageToken, goAuthLogin } from '@/utils/tools'
import { execWxConfig } from '@/utils/wxconfig'
import wx from "weixin-js-sdk"
/*
 *begin
 *引入模块路由
*/
import carrerRouter from './carrer'
import course2Router from './course2'
import measurementRouter from './measurement'
import msRouter from './measurement_system'
import trainingtRouter from './training'
import careerCollege from './career_college'
import other from './other'
import beMyself from './be_myself'
import xuanduiGadgets from './xuandui_gadgets'
/*
 *end
 *引入模块路由
*/
const isDev = process.env.NODE_ENV === 'development';
let base = isDev ? '/' : '/test/';
let root = process.env.VUE_APP_ROOT;
if(root) {
  base = '/main/';
}

// -------------------------------------------------------------
// 上线判断

// 详情页倒计时
let t0_test = true;

if(!isMain() && t0_test) {

}
// 合并路由
let routers_ = [
  ...carrerRouter,
  ...course2Router,
  ...measurementRouter,
  ...trainingtRouter,
  ...msRouter,
  ...careerCollege,
  ...other,
  ...beMyself,
  ...xuanduiGadgets
  
];
Vue.use(Router)

let route = new Router({
  mode: 'history', // history h5去锚点模式
  base: base,
  routes:routers_,
  // 路由切换，滚动条处理，回到顶部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


// 假装在加载网页
route.beforeEach(function(to, from, next) {
  // 加载开始
  NProgress.start();
  if (to.name) {
    document.title = to.name;
  }

  window.observer.subscribe('onRoute', function(){
    next();
  });
})

route.afterEach((to, from) => {
  execWxConfig();
  NProgress.done();
})

export default route
